import type { Payments } from '../../slices/payments';
import { PaymentMethodOptions } from '../../types/payments';
import { Nullable } from '../../types/utils';

export const getPayment = ({
  payments,
  premium,
}: {
  payments: Nullable<Payments>;
  premium: number | undefined;
}) => ({
  /** @clarify which fields here are mandatory and what validations/rules are applied per method/frequency */

  paymentMethod: payments.paymentMethod!,
  paymentPeriod: payments.paymentFrequency!,
  ...(payments.paymentMethod === PaymentMethodOptions.CreditCard
    ? {
        creditCardNumber: payments.creditCardNumberMasked ?? '',
        tokenizedCreditCardNumber: payments.cybersourceToken ?? '',
        creditCardType: payments.creditCardType ?? '',
        creditCardExpiry: payments.creditCardExpiryDate ?? '',
        transientToken: payments.transientToken ?? '',
      }
    : {
        accountNumber: payments.bankAccountNumber ? String(payments.bankAccountNumber) : '',
        bsb: payments.bankAccountBsb ? String(payments.bankAccountBsb) : '',
      }),

  accountName: payments.bankAccountName ?? payments.creditCardName ?? '',

  ...(payments.transactionDetail?.status && {
    transactionId: payments.transactionDetail?.transactionId ?? '',
    reasonCode: payments.transactionDetail?.reasonCode ?? '',
    totalAmount:
      payments.transactionDetail?.authAmount != null
        ? Number(payments.transactionDetail.authAmount)
        : undefined,
    cardType: payments.transactionDetail?.cardType ?? '',
    status: payments.transactionDetail?.status,
  }),

  ...(premium && { totalPremiumPaid: premium }),
});
